



































import Vue from 'vue'
import Component from 'vue-class-component'
import OccupationListItem from '@app/componentlib/src/views/components/OccupationListItem.vue'
import { IWizardStepJobTitles } from '@app/componentlib/common/types/WizardTypes'
import { IJobMatchProfile, IOccupation } from '@app/componentlib/common/types/JobMatchTypes'
import { JobMatchModule } from '@app/componentlib/src/store/modules/JobMatch/jobMatch'
import { JobMatchOccupationModule } from '@app/componentlib/src/store/modules/JobMatch/jobMatchOccupations'

@Component<WizardStepJobMatchJobtitles>({
  components: {
    OccupationListItem
  },
  props: {
    wizardstep: Object
  }
})

export default class WizardStepJobMatchJobtitles extends Vue {
  /**
   * Props variables
   */
   wizardstep: IWizardStepJobTitles | undefined

  /**
   * Component state variables
   */
  input: string | undefined = this.jobDescription
  timer = 0

  /**
   * Lifecycle
   */
  mounted() {
    if (this.jobDescription !== '') {
      JobMatchOccupationModule.getJobTitles(this.jobDescription)
    }
  }

  /**
   * Getters
   */
  get occupations (): IOccupation[] | undefined {
    return JobMatchOccupationModule.occupations ? JobMatchOccupationModule.occupations : undefined
  }

  get gettingJobMatches (): boolean {
    return JobMatchOccupationModule.gettingJobMatches
  }

  get jobDescription (): string {
    if(JobMatchModule.jobMatchProfile.currentJobDescription !== undefined && JobMatchModule.jobMatchProfile.currentJobDescription !== null) {
      return JobMatchModule.jobMatchProfile.currentJobDescription
    } else {
      return ''
    }
  }

  get jobMatchProfile (): IJobMatchProfile {
    return JobMatchModule.jobMatchProfile
  }

  /**
   * Methods
   */
  async findJobtitles () {
    if(this.input !== undefined)
      JobMatchOccupationModule.getJobTitles(this.input)
  }

  inputChanged() {
    let tempProfile = this.jobMatchProfile
    tempProfile.currentJobDescription = this.input

    if (this.timer >= 0) clearTimeout(this.timer)

    this.timer = window.setTimeout(() => {
      JobMatchModule.updateJobMatchProfile(tempProfile)
      if (this.input === '')
        JobMatchOccupationModule.setOccupations([])
    }, 800)
  }

}
